export * from "./ContentHeading";
